import Warning from '../Warning';
import { APPLICATION_PATHS } from '../../application-core/constants';
import { withRouter } from 'react-router-dom';
import GS from '../../grafsync/grafsync';
import { makeCancelable } from '../utils/utils';
import FastForwardIcon from '@material-ui/icons/FastForward';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import "@triply/yasgui/build/yasgui.min.css";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles } from '../style/gstheme';
import "../style/sparql-editor.css";
import MarketplaceDialog from './MarketplaceDialog';
import MarketplaceProcessingDialog from './MarketplaceProcessingDialog';

const styles = (theme) => {
  return Object.assign({
    marketplace: {
      textAlign: 'center',
      margin: '0px auto 12px auto',
      width: 400,
      color: theme.palette.primary.main,
      borderRadius: 26,
      padding: 6,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        cursor: 'pointer'
      },
      '&:focus-visible': {
        outline: 'dashed 2px black'
      }
    }
  }, globalStyles);
};

class MarketplaceManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showMarketplace: false,
      status: "",
      message: "",
      processing: false,
      processingComplete: false,
      project: ""
    };
    this.cancellable = null;
  }

  showMarketplace = () => {
    this.setState({ showMarketplace: true });
  };

  hideMarketplace = () => {
    this.setState({ showMarketplace: false });
  };

  componentWillUnmount() {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    if (this.cancellable) this.cancellable.cancel();
  }

  doUpload(example, targetProject) {
    this.cancellable = makeCancelable(GS.uploadExampleProject(example, targetProject));
    return this.cancellable;
  }

  loadExample = (ds) => {
    this.setState({
      transfer: null,
      processing: true,
      status: "Processing data ... please wait",
      showMarketplace: false
    }, async () => {
      try {
        const examples = ds.ids;
        let projectIRIs = [];
        for (let example of examples) {
          let targetProject = undefined;
          if (ds.references) {
            const referenceExists = ds.references.find(r => {
              return r.source === example;
            });
            if (referenceExists) {
              targetProject = projectIRIs[referenceExists.targetIndex];
            }
          }
          const resp = await this.doUpload(example, targetProject).promise;
          if (this.cancellable && this.cancellable.isCancelled()) break;
          const project = await new Promise((resolve, reject) => {
            const isTargetProject = ds.goToProject === undefined || example === ds.goToProject;
            this.setState({ uuid: resp.filename }, () => this.watchUpload(resolve, reject, isTargetProject));
          });
          projectIRIs.push(project);
        }
        this.setState({ processingComplete: true });
      }
      catch (e) {
        if (this.cancellable && this.cancellable.isCancelled()) return;
        this.setState({
          isErrored: true,
          processing: false,
          processingComplete: false,
          errorMessage: e.message
        });
      }
    });
  };

  watchUpload = (resolve, reject, isTargetProject = true) => {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    this.hcTimeout = setTimeout(async () => {
      try {
        let status = await GS.uploadStatus(this.state.uuid);
        if (this.cancellable && !this.cancellable.isCancelled()) {
          this.setState({
            ...(status.message) && { message: status.message },
            ...(status.status) && { status: status.status },
            ...(status.project && isTargetProject) && { project: status.project }
          });
          // Keep looping until ready
          if (status.transfer === undefined) {
            this.watchUpload(resolve, reject, isTargetProject);
          }
          else {
            if (status.transfer === false) {
              const messages = status.message && status.message["en"] ?
                Array.isArray(status.message["en"]) ?
                  status.message["en"]
                  :
                  [status.message["en"]]
                :
                "An error occurred.";
              reject({
                message: messages.sort().map((reason) => reason.split("\\n").join(' '))
              });
            }
            else {
              resolve(status.project);
            }
          }
        }
        else {
          resolve();
        }
      }
      catch (e) {
        reject(e);
      }
    }, 2000);
  };

  goToProject = () => {
    const link = APPLICATION_PATHS.TAXONOMY_MANAGER + '/project/detail#project=' + this.state.project;
    this.props.history.push(link);
  };

  onExitWarning = () => this.setState({ isErrored: false });

  render() {

    const { classes } = this.props;
    const { showMarketplace, processing, isErrored, errorMessage, processingComplete } = this.state;

    if (isErrored) return <Warning message={errorMessage} onExitWarning={this.onExitWarning} />;

    return (
      <div data-test="get-started" style={{ paddingTop: 48 }}>
        <div
          tabIndex={0}
          data-test="get-started-button"
          className={classes.marketplace}
          onKeyDown={(ev) => {
            if (ev.key === "Enter") {
              ev.preventDefault();
              ev.stopPropagation();
              this.showMarketplace();
            }
          }}
          onClick={this.showMarketplace}>
          <Typography align="left" className={classes.mainHeading}>
            <FastForwardIcon fontSize="large" style={{ verticalAlign: 'middle', marginLeft: 12, marginRight: 12 }} />
            <span>Get Started Using Example Data</span>
          </Typography>
        </div>
        {showMarketplace && <MarketplaceDialog
          loadExample={this.loadExample}
          onExitMarketplace={this.hideMarketplace} />}
        {processing &&
          <MarketplaceProcessingDialog
            status={processingComplete ? "All done and ready for you." : "Please wait... This should not take long."}
            complete={processingComplete}
            onGoToProject={this.goToProject} />
        }
      </div>
    );
  }
}

MarketplaceManager.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(withStyles(styles)(MarketplaceManager));